import * as d3 from 'd3';

import { errorTextColor, logInfoTextColor, logDebugTextColor, warningTextColor, blackTextColor } from '../../../common/constants';

export const colorScale = d3.scale.ordinal<string, string>()
    .domain(['DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL'])
    .range([logDebugTextColor, logInfoTextColor, warningTextColor, errorTextColor, blackTextColor]);